module.exports = () => {
  return {
    name: {
      label: '模板名称',
      type: 'input',
      value: '',
    },
  };
};

